import { render, staticRenderFns } from "./Temp.vue?vue&type=template&id=4f163f90&scoped=true&"
import script from "./Temp.vue?vue&type=script&lang=js&"
export * from "./Temp.vue?vue&type=script&lang=js&"
import style0 from "./Temp.vue?vue&type=style&index=0&id=4f163f90&prod&lang=less&"
import style1 from "./Temp.vue?vue&type=style&index=1&id=4f163f90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f163f90",
  null
  
)

export default component.exports